jQuery(document).ready(function ($) {
    /*
    if ($('body').hasClass('home')) {
        $('.site-header__search').hide();
        $('.site-header__buttons').css({
            'border-right': 'none',
            'padding-right': '0'
        })
    }
     */
});